import preparedReducer from './reducer';
import {
  requestIncidentReports,
  createIncidentReport,
  updateIncidentReport,
  deleteIncidentReport,
  requestIncidentReport,
  requestIncidentReportLink,
  pendingIncidentReport,
  approveIncidentReport,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'incidentReports';

export const selectors = state => state[SLICE_NAME];
export const getIncidentReport = (state, reportID) => state.incidentReports.info?.[reportID];

export const actions = {
  requestIncidentReports,
  createIncidentReport,
  updateIncidentReport,
  requestIncidentReport,
  requestIncidentReportLink,
  deleteIncidentReport,
  pendingIncidentReport,
  approveIncidentReport,
};
